import React from 'react'

import { Checkbox, RadioButton } from '@fourthwall/components'

import * as S from './AnalyticsFiltersSelect.styled'
import type { AnalyticsFiltersSelectProps } from './AnalyticsFiltersSelect.types'

export const AnalyticsFiltersSelect = ({ filters, onChange }: AnalyticsFiltersSelectProps) => {
  const handleCheckboxChange = (sectionTitle: string, itemValue: string, checked: boolean) =>
    onChange(sectionTitle, itemValue, checked)

  const handleRadioChange = (sectionTitle: string, itemValue: string) => {
    // For radio buttons, we need to uncheck all other items in the same group first
    const section = filters.find((s) => s.title === sectionTitle)
    if (section) {
      // Uncheck all items in the group first
      section.items.forEach((item) => {
        const currentItemValue = Array.isArray(item.value) ? item.value[0] : item.value
        if (currentItemValue !== itemValue) {
          onChange(sectionTitle, currentItemValue, false)
        }
      })
    }

    // Then check the selected item
    onChange(sectionTitle, itemValue, true)
  }

  const visibleFilters = filters.filter((section) => {
    if (section.enabled === false) return false

    if (!section.items || section.items.length === 0) return false

    const hasEnabledItems = section.items.some((item) => item.enabled !== false)
    if (!hasEnabledItems) return false

    return true
  })

  return (
    <S.Container>
      {visibleFilters.map(({ title, items, type }, index) => {
        const visibleItems = items.filter((item) => item.enabled !== false)

        if (visibleItems.length === 0) return null

        return (
          <React.Fragment key={title}>
            <S.Section>
              <S.SectionTitle>{title}</S.SectionTitle>
              {visibleItems.map((item) => {
                const itemKey = Array.isArray(item.value) ? item.value[0] : item.value
                const itemValue = Array.isArray(item.value) ? item.value[0] : item.value

                return (
                  <S.SelectItem key={itemKey}>
                    {type === 'single' ? (
                      <RadioButton
                        label={item.label}
                        value={itemValue}
                        checkedValue={item.checked ? itemValue : ''}
                        onChange={() => handleRadioChange(title, itemValue)}
                      />
                    ) : (
                      <Checkbox
                        native
                        label={item.label}
                        value={itemValue}
                        checked={item.checked}
                        onValueChange={(checked) => handleCheckboxChange(title, itemValue, checked)}
                      />
                    )}
                  </S.SelectItem>
                )
              })}
            </S.Section>
            {index + 1 < visibleFilters.length && <S.Divider />}
          </React.Fragment>
        )
      })}
    </S.Container>
  )
}
